<template>
    <div>
        <!-- Barra de filtros -->
        <div class="filter-bar-header">
            <button class="btn-filter-toggle" :class="{ active: showFilters }" @click="showFilters = !showFilters">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/>
                </svg>
                Filtros
                <span v-if="activeFilterCount > 0" class="filter-badge">{{ activeFilterCount }}</span>
                <svg class="chevron-icon" :class="{ rotated: showFilters }" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="6 9 12 15 18 9"/>
                </svg>
            </button>
            <button v-if="activeFilterCount > 0" class="btn-clear-filters" @click="clearFilters">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                </svg>
                Limpiar filtros
            </button>
        </div>

        <transition name="filter-slide">
            <div v-show="showFilters" class="filter-panel">
                <div class="filter-grid">
                    <div class="filter-item">
                        <label class="filter-label">Instalación</label>
                        <div class="filter-input-wrap">
                            <svg class="filter-input-icon" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                            </svg>
                            <input v-model="filters.gei_code" type="text" class="filter-input" placeholder="Buscar instalación..." />
                        </div>
                    </div>
                    <div class="filter-item">
                        <label class="filter-label">Documento</label>
                        <div class="filter-input-wrap">
                            <svg class="filter-input-icon" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                            </svg>
                            <input v-model="filters.document_name" type="text" class="filter-input" placeholder="Buscar documento..." />
                        </div>
                    </div>
                    <div class="filter-item">
                        <label class="filter-label">Fecha realizada</label>
                        <div class="filter-date-range">
                            <div class="filter-input-wrap">
                                <svg class="filter-input-icon" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
                                </svg>
                                <input v-model="filters.effective_date_from" type="date" class="filter-input" :max="filters.effective_date_to || undefined" />
                            </div>
                            <span class="range-separator">—</span>
                            <div class="filter-input-wrap">
                                <svg class="filter-input-icon" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
                                </svg>
                                <input v-model="filters.effective_date_to" type="date" class="filter-input" :min="filters.effective_date_from || undefined" />
                            </div>
                        </div>
                    </div>
                    <div class="filter-item">
                        <label class="filter-label">Fecha prevista</label>
                        <div class="filter-date-range">
                            <div class="filter-input-wrap">
                                <svg class="filter-input-icon" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
                                </svg>
                                <input v-model="filters.expected_date_from" type="date" class="filter-input" :max="filters.expected_date_to || undefined" />
                            </div>
                            <span class="range-separator">—</span>
                            <div class="filter-input-wrap">
                                <svg class="filter-input-icon" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
                                </svg>
                                <input v-model="filters.expected_date_to" type="date" class="filter-input" :min="filters.expected_date_from || undefined" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>

        <div>
            <table class="table-striped table-responsive">
                <thead>
                <tr>
                    <th>Instalación</th>
                    <th>Clasificación</th>
                    <th>Estado</th>
                    <th>Documento</th>
                    <th>Mantenedor</th>
                    <th>Fecha realizada</th>
                    <th>Fecha prevista</th>
                    <th>Tipología</th>
                    <th>Responsable</th>
                    <th>Empresa</th>
                    <th>Tipo</th>
                    <th>Acciones</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(detail, installation) in filteredInstallationList"
                    :key="installation">
                    <td>{{ detail.gei_code }}</td>
                    <td>{{ detail.classification }}</td>
                    <td>{{ helpers.dashboardStatusLabel(detail.status) }}</td>
                    <td>{{ detail.document_name }}</td>
                    <td>{{ detail.provider_contract_e_e && detail.provider_contract_e_e[0] && detail.provider_contract_e_e[0].provider && detail.provider_contract_e_e[0].provider.provider ? detail.provider_contract_e_e[0].provider.provider : '' }}</td>
                    <td>{{ detail.effective_date ? helpers.formatDate(detail.effective_date) : '-' }}</td>
                    <td>{{ detail.expected_date ? helpers.formatDate(detail.expected_date) : '-' }}</td>
                    <td>{{ detail.typology ? detail.typology.name : '' }}</td>
                    <td>{{ detail.master_installation.responsible ? detail.master_installation.responsible.name : '' }}</td>
                    <td>{{ detail.master_installation.company ? detail.master_installation.company.name : '' }}</td>
                    <td>{{ ocaTypeName(detail) }}</td>
                    <td class="pt-1">
                          <router-link :to="{ name: 'children_installations_gei_edit', params: { id: detail.id } }" target="_blank">
                            <b-button variant="primary">
                              Ver instalación
                            </b-button>
                          </router-link>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div>
            <button class="btn btn-primary" @click="exportToExcel">Exportar a Excel</button>
        </div>
    </div>
</template>

<script>
import {mapState} from "vuex"
import helpers from "@/resources/helpers/helpers"
import {createHelpers} from "vuex-map-fields"
import ExcelJS from "exceljs"
import {BButton} from "bootstrap-vue"

const {mapFields} = createHelpers({
    getterType: 'dashboardMetrics/getField',
    mutationType: 'dashboardMetrics/updateField',
})

export default {
    name: "InstallationsDetailsView",
    components: {BButton},
    data() {
        return {
            showRowsResume: false,
            showRowsInstallations: false,
            expandedRows: {},
            activeGroups: [],
            localInstallations: [],
            data: [],
            showLoading: false,
            showFilters: false,
            helpers,
            filters: {
                gei_code: '',
                document_name: '',
                effective_date_from: '',
                effective_date_to: '',
                expected_date_from: '',
                expected_date_to: '',
            },
        }
    },
    computed: {
        ...mapState('dashboardMetrics', ['dashboard_metrics']),
        ...mapFields({
            dashboard_metrics: 'dashboard_metrics',
            installation_list: 'installation_list',
        }),
        activeFilterCount() {
            return Object.values(this.filters).filter(v => v !== '').length
        },
        filteredInstallationList() {
            return this.installation_list.filter(detail => {
                const matchInstallation = !this.filters.gei_code ||
                    String(detail.gei_code || '').toLowerCase().includes(this.filters.gei_code.toLowerCase())
                const matchDocument = !this.filters.document_name ||
                    String(detail.document_name || '').toLowerCase().includes(this.filters.document_name.toLowerCase())
                const effectiveDate = (detail.effective_date || '').slice(0, 10)
                const matchEffectiveDate =
                    (!this.filters.effective_date_from || effectiveDate >= this.filters.effective_date_from) &&
                    (!this.filters.effective_date_to   || effectiveDate <= this.filters.effective_date_to)
                const expectedDate = (detail.expected_date || '').slice(0, 10)
                const matchExpectedDate =
                    (!this.filters.expected_date_from || expectedDate >= this.filters.expected_date_from) &&
                    (!this.filters.expected_date_to   || expectedDate <= this.filters.expected_date_to)
                return matchInstallation && matchDocument && matchEffectiveDate && matchExpectedDate
            })
        },
    },
    methods: {
        clearFilters() {
            this.filters = { gei_code: '', document_name: '', effective_date_from: '', effective_date_to: '', expected_date_from: '', expected_date_to: '' }
        },

        ocaTypeName(detail) {
          if (!['Informe Oca periódico', 'OCA Inicial'].includes(detail.document_name) || !detail.document_oca || !detail.document_oca.length)
            return ''

          const foundOca = detail.document_oca.find(o =>  helpers.formatDate(o.expected_date) ===  helpers.formatDate(detail.expected_date))

          return foundOca && foundOca.oca_type ? foundOca.oca_type.name : ''
        },

        async exportToExcel() {
            const workbook = new ExcelJS.Workbook()
            const worksheet = workbook.addWorksheet('Instalaciones')
            let isDocumentOCA = this.filteredInstallationList.find(item => item.classification === 'OCAS')

            let headers = [
                'Instalación',
                'Clasificación',
                'Estado',
                'Documento',
                'Mantenedor',
                'Fecha realizada',
                'Fecha prevista',
                'Tipología',
                'Responsable',
                'Empresa',
            ]

            if (isDocumentOCA)
              headers.push('Tipo')

            worksheet.addRow(headers)
            this.filteredInstallationList.forEach(detail => {
                worksheet.addRow([
                    detail.gei_code,
                    detail.classification,
                    this.helpers.dashboardStatusLabel(detail.status),
                    detail.document_name,
                    detail.provider_contract_e_e && detail.provider_contract_e_e[0] && detail.provider_contract_e_e[0].provider && detail.provider_contract_e_e[0].provider.provider ? detail.provider_contract_e_e[0].provider.provider : '',
                    detail.effective_date ? this.helpers.formatDate(detail.effective_date) : '-',
                    detail.expected_date ? this.helpers.formatDate(detail.expected_date) : '-',
                    detail.typology ? detail.typology.name : '',
                    detail.master_installation.responsible ? detail.master_installation.responsible.name : '-',
                    detail.master_installation.company ? detail.master_installation.company.name : '-',
                    isDocumentOCA ? this.ocaTypeName(detail) : '',
                ])
            })

            const columnWidths = [
                70, 25, 100, 20, 20, 20, 35, 45, 55, 30,
            ]

            worksheet.columns.forEach((column, index) => {
                column.width = columnWidths[index]
            })

            const buffer = await workbook.xlsx.writeBuffer()
            const blob = new Blob([buffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
            const url = window.URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.href = url
            a.download = 'instalaciones.xlsx'
            a.click()
            window.URL.revokeObjectURL(url)
        }

    },

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

[dir] .dashboard-metrics {
    font-size: 12px;
}

/* ── Filter bar ── */
.filter-bar-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 6px;
}

.btn-filter-toggle {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 5px 12px;
    font-size: 12px;
    font-weight: 500;
    color: #5e6e82;
    background: #fff;
    border: 1px solid #d8dde6;
    border-radius: 20px;
    cursor: pointer;
    transition: all 0.18s ease;

    &:hover {
        border-color: #00a7e1;
        color: #00a7e1;
        background: #e8f7fd;
    }

    &.active {
        border-color: #00a7e1;
        color: #00a7e1;
        background: #e8f7fd;
    }

    .filter-badge {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 18px;
        height: 18px;
        font-size: 10px;
        font-weight: 700;
        color: #fff;
        background: #00a7e1;
        border-radius: 50%;
    }

    .chevron-icon {
        transition: transform 0.2s ease;
        &.rotated { transform: rotate(180deg); }
    }
}

.btn-clear-filters {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 5px 10px;
    font-size: 11px;
    font-weight: 500;
    color: #ea5455;
    background: #fff5f5;
    border: 1px solid #f8c5c5;
    border-radius: 20px;
    cursor: pointer;
    transition: all 0.18s ease;

    &:hover {
        background: #ffeaea;
        border-color: #ea5455;
    }
}

/* ── Filter panel ── */
.filter-panel {
    background: transparent;
    border: 1px solid #ddd;
    border-radius: 10px;
    padding: 14px 16px;
    margin-bottom: 10px;
}

.filter-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 12px;

    @media (max-width: 900px) {
        grid-template-columns: repeat(2, 1fr);
    }
}

.filter-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.filter-label {
    font-size: 11px;
    font-weight: 600;
    color: #3d3d3d;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin: 0;
}

.filter-input-wrap {
    position: relative;
    display: flex;
    align-items: center;

    .filter-input-icon {
        position: absolute;
        left: 9px;
        color: #aaa;
        pointer-events: none;
        flex-shrink: 0;
    }
}

.filter-input {
    width: 100%;
    padding: 6px 10px 6px 28px;
    font-size: 12px;
    color: #3d3d3d;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 6px;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
    outline: none;

    &:focus {
        border-color: #00a7e1;
        box-shadow: 0 0 0 3px rgba(0, 167, 225, 0.15);
    }

    &[type="date"] {
        padding-left: 28px;
        color-scheme: light;
    }
}

.filter-date-range {
    display: flex;
    align-items: center;
    gap: 6px;

    .filter-input-wrap {
        flex: 1;
        min-width: 0;
    }
}

.range-separator {
    flex-shrink: 0;
    color: #aaa;
    font-size: 12px;
    line-height: 1;
}

/* ── Slide transition ── */
.filter-slide-enter-active,
.filter-slide-leave-active {
    transition: max-height 0.25s ease, opacity 0.2s ease;
    max-height: 200px;
    overflow: hidden;
}

.filter-slide-enter,
.filter-slide-leave-to {
    max-height: 0;
    opacity: 0;
}
</style>
